export enum Sections {
  SIGN_IN = "SIGN_IN",
  NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED",
  TWO_FACTOR_AUTHENTICATION = "TWO_FACTOR_AUTHENTICATION",
  EMAIL_CHECK = "EMAIL_CHECK",
}
